export { default } from './ModulMiradaGlobal';
